import { useEffect, useRef } from 'react';
import { Check } from 'lucide-react';
import { cn } from '../../lib/utils';

const STEPS = [
  { key: 'welcome', label: 'Welcome' },
  { key: 'upload', label: 'Upload' },
  { key: 'map', label: 'Map Columns' },
  { key: 'preview', label: 'Preview' },
  { key: 'duplicates', label: 'Duplicates' },
  { key: 'results', label: 'Import' },
];

export function WizardStepper({ currentStep, onStepClick, locked = false }) {
  const currentIndex = STEPS.findIndex(s => s.key === currentStep);
  const activeRef = useRef(null);

  useEffect(() => {
    activeRef.current?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }, [currentStep]);

  return (
    <div className="grid grid-cols-3 gap-y-3 sm:flex items-center w-full pb-1" data-testid="wizard-stepper">
      {STEPS.map((step, idx) => {
        const isDone = idx < currentIndex;
        const isCurrent = idx === currentIndex;
        const clickable = isDone && !locked;
        return (
          <div key={step.key} className="flex justify-center sm:justify-start items-center min-w-0 sm:shrink-0 sm:last:flex-1" ref={isCurrent ? activeRef : undefined}>
            <button
              type="button"
              disabled={!clickable}
              onClick={() => clickable && onStepClick?.(step.key)}
              data-testid={`wizard-step-${step.key}`}
              className={cn(
                'flex flex-col sm:flex-row items-center gap-1 sm:gap-2 px-2 py-1 rounded-md transition-colors',
                clickable ? 'cursor-pointer hover:bg-muted' : 'cursor-default'
              )}
            >
              <span className={cn(
                'h-6 w-6 rounded-full flex items-center justify-center text-[11px] font-semibold shrink-0 transition-colors',
                isDone ? 'bg-primary text-primary-foreground' :
                isCurrent ? 'bg-primary/15 text-primary border-2 border-primary' :
                'bg-muted text-muted-foreground'
              )}>
                {isDone ? <Check className="h-3 w-3" /> : idx + 1}
              </span>
              <span className={cn(
                'text-xs font-medium whitespace-nowrap',
                isCurrent ? 'text-foreground' : isDone ? 'text-foreground/80' : 'text-muted-foreground'
              )}>
                {step.label}
              </span>
            </button>
            {idx < STEPS.length - 1 && (
              <div className={cn('hidden sm:block h-px flex-1 min-w-[16px] mx-1', isDone ? 'bg-primary' : 'bg-border')} />
            )}
          </div>
        );
      })}
    </div>
  );
}

export const WIZARD_STEP_KEYS = STEPS.map(s => s.key);
